export default __webpack_public_path__ + "static/thumbnail-a0aadf37c0b6fb160ac4d38477d3fe56.jpg";